import React from 'react'

import { Alert } from '@mui/material'

import DOMPurify from 'isomorphic-dompurify'

import * as styles from './styles'

interface Props {
  message: string
}

const SEVERITY = 'error'

export const ErrorMessage = ({ message }: Props) => {
  const sanitizedError = DOMPurify.sanitize(message)

  return (
    <Alert severity={SEVERITY} sx={styles.linkStyles}>
      <div dangerouslySetInnerHTML={{ __html: sanitizedError }} />
    </Alert>
  )
}
